const reactEnv = (key, defaultValue) => {
    let value = process.env[`REACT_APP_${key.toUpperCase()}`];
    if (value) return value;
    return defaultValue || '';
};

export default reactEnv;
